import React, { useState, useEffect } from "react";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import { Row, Col, Card, CardHeader, CardBody, Button } from "reactstrap";
import LoaderSpinner from "../../Widgets/LoaderSpinner";
import EditInfoModal from "./EditInfoModal";
import PartnerBusinessesModal from "./PartnerBusinessesModal";
import EditSettingsModal from "./EditSettingsModal";
import ConfirmationModal from "../../Components/ConfirmationModal";
import PartnerGeofencesModal from "./PartnerGeofencesModal";

import withAlertTimeout from "../../../HOCs/withAlertTimeout";
import Alert from "../../Widgets/Alert";

const ViewSinglePartner = props => {
  const [isFetching, setIsFetching] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [partnerData, setPartnerData] = useState(null);
  const [infoModal, setInfoModal] = useState(false);
  const [partnerBusinessesModal, setPartnerBusinessesModal] = useState(false);
  const [partnerSettingsModal, setPartnerSettingsModal] = useState(false);
  const [partnerGeofencesModal, setPartnerGeofencesModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [categoryGroups, setCategoryGroups] = useState([]);
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [redirect, setRedirect] = useState(false);

  const token = sessionStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };

  const fetchPartnerData = async () => {
    try {
      setIsFetching(true);
      const { data } = await axios.get(
        `/api/proxy/v2/partneradmin/${props.match.params.id}`,
        { headers }
      );
      setPartnerData(data);
    } catch (e) {
      console.log(e.response || e);
    } finally {
      setIsFetching(false);
    }
  };

  const fetchCategoryGroups = async () => {
    try {
      const { data } = await axios.get(
        `/api/proxy/v2/partneradmin/${props.match.params.id}/categoryGroup`,
        { headers }
      );
      setCategoryGroups(data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchPartnerData();
    fetchCategoryGroups();
  }, []);

  const onInfoUpdated = newData => {
    setPartnerData(newData);
    setInfoModal(false);
    setPartnerBusinessesModal(false);
    setPartnerSettingsModal(false);
    setPartnerGeofencesModal(false);
    setConfirmationModal(false);
    props.showSuccess();
  };

  const renderBusinesses = () => {
    if (partnerData && partnerData.businesses.length) {
      return partnerData.businesses.map(business => (
        <div key={business.id}>
          {business.name} - {business.id}
        </div>
      ));
    }

    return <div>None</div>;
  };

  const renderGeofences = () => {
    if (partnerData && partnerData.geofences.length) {
      return partnerData.geofences.map(geofence => {
        return <div key={geofence.slug}>{geofence.city}</div>;
      });
    }
    return <div>none</div>;
  };

  const renderCategoryGroups = () => {
    if (categoryGroups.length) {
      return categoryGroups.map(group => (
        <Link
          style={{ display: "block" }}
          key={group.id}
          to={{
            pathname: `/partners/${partnerData.id}/category-groups/edit/${
              group.id
            }`,
            state: {
              partnerName: partnerData.name,
              categoryGroup: group,
              referrer: props.location.pathname
            }
          }}
        >
          {group.name}
        </Link>
      ));
    }
    return <div>none</div>;
  };

  const generateNewKey = async () => {
    try {
      setIsSubmitting(true);

      const { data } = await axios.put(
        `/api/proxy/v2/partneradmin/${partnerData.id}/apikey`,
        {},
        { headers }
      );

      onInfoUpdated({ ...partnerData, apiKey: data.apiKey });
    } catch (e) {
      console.log(e.response || e);
      props.showFailure();
    } finally {
      setIsSubmitting(false);
    }
  };

  const deletePartner = async () => {
    try {
      setIsSubmitting(true);
      await axios.delete(`/api/proxy/v2/partneradmin/${partnerData.id}`, {
        headers
      });
      setIsSubmitting(false);
      setRedirect(true);
    } catch (e) {
      console.log(e.response || e);
      props.showFailure();
      setIsSubmitting(false);
    }
  };

  if (redirect) {
    return <Redirect to="/partnership/view-partners" />;
  }

  return (
    <React.Fragment>
      {partnerData && (
        <React.Fragment>
          <EditInfoModal
            partner={partnerData}
            isOpen={infoModal}
            close={() => setInfoModal(false)}
            onSuccess={onInfoUpdated}
          />
          <PartnerBusinessesModal
            partner={partnerData}
            isOpen={partnerBusinessesModal}
            close={() => setPartnerBusinessesModal(false)}
            onSuccess={onInfoUpdated}
          />
          <EditSettingsModal
            partner={partnerData}
            isOpen={partnerSettingsModal}
            close={() => setPartnerSettingsModal(false)}
            onSuccess={onInfoUpdated}
          />
          <PartnerGeofencesModal
            partner={partnerData}
            isOpen={partnerGeofencesModal}
            close={() => setPartnerGeofencesModal(false)}
            onSuccess={onInfoUpdated}
          />
          <ConfirmationModal
            message={"Are you sure you want to generate a new API key?"}
            open={confirmationModal}
            close={() => setConfirmationModal(false)}
            onConfirm={generateNewKey}
            isSubmitting={isSubmitting}
          />
          <ConfirmationModal
            message={
              "Are you sure you want to delete this partner? This action is permanent."
            }
            open={deleteConfirmationModal}
            close={() => setDeleteConfirmationModal(false)}
            onConfirm={deletePartner}
            isSubmitting={isSubmitting}
          />
        </React.Fragment>
      )}
      <Alert active={props.success} message="Partner Updated" />
      <Row>
        <Col xs="12" md="8">
          {isFetching && <LoaderSpinner />}

          {partnerData && (
            <Card>
              <CardHeader>{partnerData.name}</CardHeader>
              <CardBody>
                <h5
                  style={{ borderBottom: "1px solid", width: 75 }}
                  className="bold"
                >
                  General
                </h5>
                <div style={{ marginTop: 10 }}>
                  <span className="bold">Name:</span> {partnerData.name}
                </div>
                <div style={{ marginTop: 10 }}>
                  <span className="bold">Description:</span>
                  <p>{partnerData.description}</p>
                </div>
                <div style={{ marginTop: 10 }}>
                  <span className="bold">API key:</span> {partnerData.apiKey}
                </div>
                <div style={{ marginTop: 10 }}>
                  <h5
                    style={{ borderBottom: "1px solid", width: 75 }}
                    className="bold"
                  >
                    Settings
                  </h5>
                </div>

                <div style={{ marginTop: 10 }}>
                  <span className="bold">Data Frequency:</span>{" "}
                  {partnerData.settings.dataFrequencySetting}
                </div>
                <div style={{ marginTop: 10 }}>
                  <span className="bold">Number Per Business:</span>{" "}
                  {partnerData.settings.numberPerBusiness}
                </div>
                <div style={{ marginTop: 10 }}>
                  <span className="bold">Filter Type:</span>{" "}
                  {partnerData.settings.partnerFilterType}
                </div>
                <div style={{ marginTop: 10 }}>
                  <span className="bold">Requests Per Day:</span>{" "}
                  {partnerData.settings.requestsPerDay}
                </div>
                <div style={{ marginTop: 10 }}>
                  <h5
                    style={{ borderBottom: "1px solid", width: 100 }}
                    className="bold"
                  >
                    Businesses
                  </h5>
                  <div style={{ marginTop: 10 }}>{renderBusinesses()}</div>
                </div>
                <div style={{ marginTop: 10 }}>
                  <h5
                    style={{ borderBottom: "1px solid", width: 100 }}
                    className="bold"
                  >
                    Geofences
                  </h5>
                  <div style={{ marginTop: 10 }}>{renderGeofences()}</div>
                </div>
                <div style={{ marginTop: 10 }}>
                  <h5
                    style={{ borderBottom: "1px solid", width: 150 }}
                    className="bold"
                  >
                    Category Groups
                  </h5>
                  <div style={{ marginTop: 10 }}>{renderCategoryGroups()}</div>
                </div>
              </CardBody>
            </Card>
          )}
        </Col>
        <Col
          xs="12"
          md="3"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <Button disabled={!partnerData} onClick={() => setInfoModal(true)}>
            Edit Info
          </Button>
          <Button
            disabled={!partnerData}
            onClick={() => setPartnerSettingsModal(true)}
            style={{ marginTop: 10 }}
          >
            Update Settings
          </Button>
          <Button
            disabled={!partnerData}
            onClick={() => setPartnerBusinessesModal(true)}
            style={{ marginTop: 10 }}
          >
            Add/Remove Businesses
          </Button>
          <Button
            disabled={!partnerData}
            onClick={() => setPartnerGeofencesModal(true)}
            style={{ marginTop: 10 }}
          >
            Add Geofences
          </Button>
          <Button
            disabled={!partnerData}
            onClick={() => setConfirmationModal(true)}
            style={{ marginTop: 10 }}
          >
            Generate New API Key
          </Button>
          {partnerData ? (
            <Link
              to={{
                pathname: `/partners/${partnerData.id}/category-groups/create`,
                state: {
                  partnerName: partnerData.name
                }
              }}
            >
              <Button style={{ marginTop: 10, width: "100%" }}>
                Create Category Group
              </Button>
            </Link>
          ) : null}

          <Button
            disabled={!partnerData}
            onClick={() => setDeleteConfirmationModal(true)}
            style={{
              marginTop: 10,
              color: "#f2014b",
              border: "1px solid #f2014b",
              backgroundColor: "transparent"
            }}
          >
            Delete Partner
          </Button>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default withAlertTimeout(ViewSinglePartner);



// WEBPACK FOOTER //
// ./src/views/Pages/Partnership/ViewSinglePartner.js